/* src/app/portal/shared/home/home.component.scss */
.card-header {
  background-color: #2a71bf;
  height: 37px;
  line-height: 0.5;
}
.card-header label {
  color: #f3f3f3;
  font-size: 14px;
  font-weight: 500;
  margin-left: -10px;
}
.card-header .actions {
  float: right;
  margin: -6px -20px 0px 0px;
}
.card-header .actions label {
  font-size: 15px;
  font-weight: 400;
}
.card-header .actions label {
  font-size: 15px;
  font-weight: 400;
}
.card-header .actions select {
  line-height: 0.5;
  height: 27px;
  width: 115px;
  background-color: #f3f3f3;
  color: black;
  font-size: 12px;
  margin: 0px 5px 0px 5px;
  border-radius: 4px;
}
.card-header .actions .btn {
  line-height: 0.5;
  height: 26px;
  background-color: #f3f3f3;
  color: black;
  font-size: 12px;
  margin: -3px 5px 0px 5px;
}
.card-header .actions .btn i {
  font-size: 18px;
  line-height: 0.5;
  margin-top: 2px;
}
.card-header .actions .zoom {
  float: left;
  margin: 2px 15px 0px 0px;
}
/*# sourceMappingURL=home.component-ALBFGJGK.css.map */
